interface Params {
  items: string[];
  style: "unordered" | "ordered";
}

export const list = ({ items, style }: Params, blurred: boolean) => {
  if (!items.length) {
    return "";
  }

  const styleTag = style === "ordered" ? "ol" : "ul";
  const itemTags = items.map((item) => `<li>${item}</li>`).join("");

  return blurred ?
      `<${styleTag} class="blurred">${itemTags}</${styleTag}>`
      : `<${styleTag}>${itemTags}</${styleTag}>`;
};
